import { memo } from 'react'
import { DepositItem } from '../deposits-list/deposit-item'
import { useRecoilValue } from 'recoil'
import { selectedAccountState } from '../../states/selected-account-id'
import { ACLContainer } from '../acl-container/acl-container'

const Component = () => {
  const account = useRecoilValue(selectedAccountState)
  const deposits = account?.deposits || []

  return (
    <div>
      <h1 className="text-2xl font-bold">My Deposits </h1>
      <table className="table table-compact w-full b-4 mt-4 mb-4">
        <thead>
          <tr>
            <th>Amount</th>
            <th>Date</th>
            <ACLContainer onlyManagement isEditableOnly>
              <th>Account</th>
              <th />
            </ACLContainer>
          </tr>
        </thead>
        <tbody>
          {deposits.map((item) => (
            <DepositItem
              key={item.id}
              id={item.id}
              realizedAt={item.realizedAt}
              amount={item.amount}
              currencyCode={item.currency?.code}
              showId={false}
              accountName={item.account?.name}
            />
          ))}
        </tbody>
      </table>
      {deposits.length === 0 && (
        <div className="alert alert-primary">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-current flex-shrink-0 w-6 h-6">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>No deposits yet</span>
          </div>
        </div>
      )}
    </div>
  )
}

export const MyDeposits = memo(Component)